import React, { Component } from 'react';
import { request } from "../../util/APIUtils";
import { API_BASE_URL } from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import "./Youtube.css";

class Youtube extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videos: [],
            loading: false,
            error: null,
        };
    }

    componentDidMount() {
        this.fetchVideos();
    }

    fetchVideos = () => {
        this.setState({ loading: true });

        const params = {
            url: `${API_BASE_URL}/youtube/videos?username=sanliurfaeczaciodasi27`,
            method: "GET",
        };

        request(params)
            .then(response => {
                console.log("API Yanıtı:", response);
                if (Array.isArray(response.data) && response.data.length > 0) {
                    const videos = response.data.map(item => ({
                        etag: item.etag,
                        id: item.id.videoId,
                        snippet: {
                            channelId: item.snippet.channelId,
                            channelTitle: item.snippet.channelTitle,
                            publishedAt: item.snippet.publishedAt,
                            thumbnails: item.snippet.thumbnails,
                            title: item.snippet.title,
                        }
                    }));
                    this.setState({
                        videos: videos,
                        loading: false,
                        error: null
                    });
                } else {
                    this.setState({
                        error: "Yanıtta video verisi bulunamadı.",
                        loading: false,
                        videos: []
                    });
                }
            })
            .catch(error => {
                this.setState({
                    error: "Videolar yüklenirken bir sorun oluştu.",
                    loading: false,
                    videos: []
                });
                console.error("YouTube API Hatası:", error);
            });
    }

    render() {
        const { videos, loading, error } = this.state;

        console.log("Video Verileri:", videos);

        return (
            <div className="youtube-videos">
                 <h4 >Video Yayınlarımız</h4>
                {loading && <LoadingIndicator />}
                {error && <div className="error">{error}</div>}
                <div className="video-list">
                    {videos.length > 0 ? (
                        videos.map((video, index) => (
                            <div key={index} className="video-item">
                                <div className="card-youtube">
                                    <img className="card-img-youtube" src={video.snippet.thumbnails.medium.url} alt={video.snippet.title} />
                                    <div className="card-body-youtube">
                                        <h5 className="card-title-youtube">{video.snippet.title}</h5>
                                        <p className="card-text-youtube">{video.snippet.description}</p>
                                        <a href={`https://www.youtube.com/watch?v=${video.id}`} className="btn-youtube btn-youtube-red" target="_blank" rel="noopener noreferrer">Videoyu İzle</a>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        !loading && <div>Gösterilecek video yok.</div>
                    )}
                </div>
            </div>
        );
    }
}

export default Youtube;



// WEBPACK FOOTER //
// ./src/page/youtube/Youtube.js